<template>
  <div class="book-course-rule-alert">
    <span class="l">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 12.373C9.5 12.373 9.0625 12.8105 9.0625 13.3105C9.0625 13.8105 9.5 14.248 10 14.248C10.5 14.248 10.9375 13.8105 10.9375 13.3105C10.9375 12.8105 10.5 12.373 10 12.373Z"
          fill="#FF5555"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 10.9385C10.5 10.9385 10.9375 10.501 10.9375 10.001V6.00098C10.9375 5.50098 10.5 5.06348 10 5.06348C9.5 5.06348 9.0625 5.50098 9.0625 6.00098V10.001C9.0625 10.501 9.5 10.9385 10 10.9385Z"
          fill="#FF5555"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.0001 3.33341C6.31818 3.33341 3.33341 6.31818 3.33341 10.0001C3.33341 13.682 6.31818 16.6667 10.0001 16.6667C13.682 16.6667 16.6667 13.682 16.6667 10.0001C16.6667 6.31818 13.682 3.33341 10.0001 3.33341ZM1.66675 10.0001C1.66675 5.39771 5.39771 1.66675 10.0001 1.66675C14.6025 1.66675 18.3334 5.39771 18.3334 10.0001C18.3334 14.6025 14.6025 18.3334 10.0001 18.3334C5.39771 18.3334 1.66675 14.6025 1.66675 10.0001Z"
          fill="#FF5555"
        />
      </svg>
      <span class="info">调换上课规则说明</span>
    </span>
    <span class="r" @click="handleKnow">查看</span>
  </div>
</template>

<script>
export default {
  name: 'BookCourseRuleAlert',
  methods: {
    handleKnow() {
      this.$emit('onClick');
    },
    doBook() {
      this.$emit('onBook');
    },
  },
};
</script>

<style lang="scss" scoped>
.book-course-rule-alert {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 400;
  margin-bottom: 16px;

  font-size: 14px;
  color: #1d1b20;
  background-color: #ffefef;
  border-radius: 8px;
  padding: 6px 12px;

  .info {
    margin-left: 4px;
  }
  .l {
    display: inline-flex;
    align-items: center;
    line-height: 20px;
  }
  .r {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    color: #ff2020;
  }
}
</style>
